import type { Component } from 'vue';
import {
  Building2,
  GitBranch,
  Globe,
  LayoutGrid,
  TriangleAlert,
  Users,
} from 'lucide-vue-next';

export interface MenuItem {
  labelKey: string;
  to: string;
  icon: Component;
}

export const MENU_ITEMS: MenuItem[] = [
  { labelKey: 'NAV.dealers', to: '/dealers', icon: Users },
  { labelKey: 'NAV.dispatchers', to: '/dispatchers', icon: GitBranch },
  { labelKey: 'NAV.templates', to: '/templates', icon: LayoutGrid },
  { labelKey: 'NAV.importFlow', to: '/import-flow', icon: TriangleAlert },
  { labelKey: 'NAV.dmsIntegration', to: '/dms-integration', icon: Globe },
];

export const HOME_ITEM: MenuItem = {
  labelKey: 'NAV.home',
  to: '/',
  icon: Building2,
};
